<template>
  <div ref="cellTooltipWrap" class="cell-tooltip">
    <!-- 默认显示，无tooltip -->
    <span v-if="!showTooltip">{{ showText }}</span>
    <!-- tooltip存在 -->
    <el-tooltip
      v-if="showTooltip"
      class="item"
      effect="dark"
      placement="top"
      popper-class="edm-tooltip"
    >
      <div slot="content" class="tooltip-content">{{ text }}</div>
      <span v-html="showText"></span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "CellTooltip",
  props: {
    text: [String, Number],
    limit: {
      type: Number,
      default: 32
    },
    width: String || Function,
    row: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      showTooltip: false,
      showText: ""
    };
  },
  watch: {
    text: {
      handler(val) {
        this.getStrByWith();
      },
      deep: true,
      immediate: true
    },

    /*
     * width: {
     *   handler(){
     *     this.getStrByWith();
     *   },
     *   immediate: true
     * }
     */
    width() {
      this.getStrByWith();
    }
  },
  mounted() {
  },
  methods: {
    getStrByWith() {
      this.$nextTick(() => {
        this.showTooltip = false;
        if (text === "" || this.text === undefined || this.text === null) { return; }
        const text = `${this.text}`;
        if (text.length > this.limit) {
          let width = 0;
          if (!this.width || isNaN(this.width / 1)) {
            const root = this.$refs.cellTooltipWrap;
            root && (width = root.clientWidth);
          } else {
            width = this.width - 30;
          }
          if (!width || isNaN(width)) { return; }
          const span = document.createElement("span");
          span.id = `cut_${parseInt(Math.random() * 10000000)}`;
          span.style.visibility = "hidden";
          span.style.fontSize = "14px";
          span.style.whiteSpace = "nowrap";
          document.body.appendChild(span);
          let temp = ""; // 存放截断字符串
          let num = 0;
          // 这里是循环第一行
          let isLessOneRow = true;
          for (let j = 0; j < text.length; j++) {
            temp += text[j];
            num++;
            span.innerText = temp;
            if (span.offsetWidth > (width * this.row)) {
              isLessOneRow = false;
              temp = temp.substring(0, temp.length - 1);
              num--;
              break;
            }
          }
          document.body.removeChild(span);
          if (!isLessOneRow) {
            if (text.length > num) {
              temp = text.substring(0, num - 3);
              temp += "...";
              this.showTooltip = true;
            } else {
              temp = text;
            }
          }
          this.showText = temp;
        } else {
          this.showText = text;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip-content {
  height: auto;
  max-height: calc(100vh / 3);
  overflow-y: auto;

  &::-webkit-scrollbar {
    z-index: 11;
    width: 6px;
  }

  &::-webkit-scrollbar:horizontal {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    width: 6px;
    background: #b4bccc;
    border-radius: 5px;
  }
  // &::-webkit-scrollbar-corner {
  //   background: #fff;
  // }
  // &::-webkit-scrollbar-track {
  //   background: #fff;
  // }
  // &::-webkit-scrollbar-track-piece {
  //   background: #fff;
  //   width: 6px;
  // }
}
</style>
